// 検索
export const TAB_INFO_SET = "search/TAB_INFO_SET";
